export enum ResourceSectionType {
  OperationalModules = 'operational-modules',
  Demand = 'demand',
  BusModule = 'bus-module',
  Resources = 'resources',
  Places = 'places',
  Favourites = 'favourites',
  Settings = 'settings',
}
